import { render, staticRenderFns } from "./ContingentView.vue?vue&type=template&id=2779758a&scoped=true&"
import script from "./ContingentView.vue?vue&type=script&lang=ts&"
export * from "./ContingentView.vue?vue&type=script&lang=ts&"
import style0 from "./ContingentView.vue?vue&type=style&index=0&id=2779758a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779758a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCardText,VCardTitle,VFlex,VLayout,VProgressCircular})
